import React, {useEffect, useRef} from "react";

const ScriptLoader = ({ async = true, children, src, onLoad }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (
      ref.current.lastChild &&
      ref.current.lastChild.getAttribute("src") === src
    ) {
      return;
    }
    const script = document.createElement("script");
    script.setAttribute("async", async);
    script.setAttribute("src", src);

    script.onload = onLoad;

    ref.current.appendChild(script);
  }, [async, src, onLoad]);

  return <div ref={ref}>{children}</div>;
}

export const Yandex = ({ children, renderTo }) => {
  return (
    <ScriptLoader
      src="https://yandex.ru/ads/system/context.js"
      onLoad={(...args) => {
        // eslint-disable-next-line
        if (typeof Ya !== "undefined" && Ya !== null) {
          window.yaContextCb.push(() => {
            // eslint-disable-next-line
            Ya.Context.AdvManager.render({
              blockId: "R-A-14983406-3",
              renderTo,
              async: true,
            });
          });
        }
      }}
    >
      <div id={renderTo} className='ads ads--type-2 ads--ya-ads'>
        <div className='ads__placeholder'/>
      </div>
      {children}
    </ScriptLoader>
  );
}
